import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-start flex-wrap" }
const _hoisted_2 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_3 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_4 = {
  key: 0,
  class: "text-red"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "text-red"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "text-red"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "text-red"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: "index" }
const _hoisted_13 = { key: "decl.id" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  class: "text-center",
  style: {"width":"50px"}
}
const _hoisted_16 = {
  class: "text-left",
  style: {"width":"300px"}
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  class: "text-right",
  style: {"width":"100px"}
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  class: "text-right",
  style: {"width":"100px"}
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  key: 0,
  class: "px-0"
}
const _hoisted_29 = {
  colspan: "100",
  class: "px-0"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  class: "text-center",
  style: {"width":"50px"}
}
const _hoisted_32 = {
  class: "text-left",
  style: {"width":"300px"}
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = {
  class: "text-right",
  style: {"border-left":"1px solid #dddddd","width":"100px"}
}
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  class: "text-right",
  style: {"border-left":"1px solid #dddddd","width":"100px"}
}
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = {
  class: "text-right",
  style: {"border-right":"1px solid #dddddd","width":"100px"}
}
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = {
  key: 0,
  class: "px-0"
}
const _hoisted_48 = {
  colspan: "100",
  class: "px-0"
}
const _hoisted_49 = ["onClick"]
const _hoisted_50 = {
  class: "text-center",
  style: {"width":"50px"}
}
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = {
  class: "text-right",
  style: {"width":"100px"}
}
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = {
  class: "text-right",
  style: {"width":"100px"}
}
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = {
  class: "text-right",
  style: {"width":"100px"}
}
const _hoisted_60 = { key: 0 }
const _hoisted_61 = {
  key: 1,
  style: {"width":"100px"}
}
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = {
  key: 0,
  class: "px-0"
}
const _hoisted_65 = {
  colspan: "100",
  class: "px-0"
}
const _hoisted_66 = {
  class: "text-left",
  style: {"width":"300px"}
}
const _hoisted_67 = {
  class: "text-right",
  style: {"width":"100px"}
}
const _hoisted_68 = {
  class: "text-right",
  style: {"width":"100px"}
}
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { key: 1 }
const _hoisted_71 = { class: "pl-8" }
const _hoisted_72 = { class: "pl-8" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = {
  class: "text-center",
  style: {"width":"50px"}
}
const _hoisted_75 = {
  class: "text-center",
  style: {"width":"50px"}
}
const _hoisted_76 = { style: {"width":"300px"} }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { key: 1 }
const _hoisted_79 = {
  class: "text-right",
  style: {"width":"100px"}
}
const _hoisted_80 = { key: 0 }
const _hoisted_81 = {
  class: "text-right",
  style: {"width":"100px"}
}
const _hoisted_82 = { key: 0 }
const _hoisted_83 = { key: 1 }
const _hoisted_84 = { key: 1 }
const _hoisted_85 = { key: 2 }
const _hoisted_86 = {
  key: 0,
  class: "px-0"
}
const _hoisted_87 = {
  colspan: "100",
  class: "px-0"
}
const _hoisted_88 = { style: {"width":"300px"} }
const _hoisted_89 = {
  class: "text-right",
  style: {"width":"100px"}
}
const _hoisted_90 = { key: 0 }
const _hoisted_91 = {
  class: "text-right",
  style: {"width":"100px"}
}
const _hoisted_92 = { key: 0 }
const _hoisted_93 = { key: 1 }
const _hoisted_94 = { key: 1 }
const _hoisted_95 = { key: 2 }
const _hoisted_96 = { class: "pl-8" }
const _hoisted_97 = {
  key: 0,
  class: "mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_GeneralLedger = _resolveComponent("GeneralLedger")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_AuditConnectedAcrDocuments = _resolveComponent("AuditConnectedAcrDocuments")!
  const _component_AuditConnectedAcrResults = _resolveComponent("AuditConnectedAcrResults")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_AccountingItemEdition2 = _resolveComponent("AccountingItemEdition2")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_AuditCheckDocumentsManager = _resolveComponent("AuditCheckDocumentsManager")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_DeclarationForm = _resolveComponent("DeclarationForm")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window, {
        modelValue: _ctx.globalStep,
        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.globalStep) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { class: "d-flex mb-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "auto",
                    class: "d-flex align-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_back, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'auditReport' })))
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "align-center justify-start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createElementVNode("h2", _hoisted_1, [
                                _cache[40] || (_cache[40] = _createTextVNode(" Rapprochement Chiffre d'affaires / T.V.A. déclarée ")),
                                _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_icon, _mergeProps({ color: "secondary" }, props, {
                                      class: "ml-2",
                                      icon: "$oss-help"
                                    }), null, 16)
                                  ]),
                                  default: _withCtx(() => [
                                    _cache[35] || (_cache[35] = _createElementVNode("h3", null, " Si les écarts sont nuls, le rapprochement est validé automatiquement. ", -1)),
                                    _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
                                    _cache[37] || (_cache[37] = _createElementVNode("hr", null, null, -1)),
                                    _cache[38] || (_cache[38] = _createElementVNode("h4", null, " Ce contrôle construit les tableaux repartis par taux, se basant sur les lignes pas lettrés, en fin d'exercices N-1 et N, des comptes 411 416 418 419 487. ", -1)),
                                    _cache[39] || (_cache[39] = _createElementVNode("h3", null, " Il est indispensable que les lettrages soyent terminés, sinon des documents seront ajoutés au calcul et les écarts faussés. ", -1))
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "d-flex align-center justify-start flex-wrap"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(`Statut : ${_ctx.checkStatus}`), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "5",
                    class: "d-flex flex-grow-0 flex-shrink-0 justify-end align-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_tooltip, {
                        location: "bottom",
                        text: "Lier un document"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps({
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogAuditCheckDocumentsManager = true))
                          }, props, {
                            size: "x-small",
                            icon: "$oss-upload",
                            class: "mx-1"
                          }), null, 16)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps({
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openChat = !_ctx.openChat))
                          }, props, {
                            size: "x-small",
                            icon: "$oss-chat",
                            class: "mx-1"
                          }), null, 16)
                        ]),
                        default: _withCtx(() => [
                          _cache[41] || (_cache[41] = _createElementVNode("span", null, "Message", -1))
                        ]),
                        _: 1
                      }),
                      (_ctx.accountingPeriod && _ctx.accountingPeriod.closed)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            disabled: "",
                            size: "small",
                            class: "mx-1"
                          }, {
                            default: _withCtx(() => _cache[42] || (_cache[42] = [
                              _createTextVNode(" Enregistrer ")
                            ])),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.validateAuditCheckResult()), ["stop"])),
                            size: "small",
                            class: "mx-1"
                          }, {
                            default: _withCtx(() => _cache[43] || (_cache[43] = [
                              _createTextVNode(" Enregistrer ")
                            ])),
                            _: 1
                          })),
                      _createVNode(_component_v_btn, {
                        disabled: 
                                    _ctx.loading ||
                                    _ctx.dataLoading ||
                                    !_ctx.accountingPeriod ||
                                    !_ctx.accountingPeriod ||
                                    (_ctx.accountingPeriod && _ctx.accountingPeriod.closed)
                                ,
                        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => {_ctx.validated = !_ctx.validated; _ctx.validateAuditCheckResult()}, ["stop"])),
                        size: "small",
                        class: "mx-1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.validated ? "Invalider" : "Valider"), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      (_ctx.isEnableReview)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _cache[45] || (_cache[45] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"2px","height":"25px","margin":"0 4px"} }, null, -1)),
                            _createVNode(_component_v_icon, {
                              disabled: 
                                        _ctx.reviewed === 1 ||
                                        !_ctx.isEnableReview ||
                                        !_ctx.validated ||
                                        _ctx.loading ||
                                        _ctx.dataLoading
                                    ,
                              size: "small",
                              icon: "$fa-thumbs-up",
                              color: "primary",
                              class: "mx-1",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => {
                                        _ctx.reviewed = 1;
                                        _ctx.validateAuditCheckResult('REVIEW');
                                    })
                            }, {
                              default: _withCtx(() => _cache[44] || (_cache[44] = [
                                _createTextVNode("$fa-thumbs-up")
                              ])),
                              _: 1
                            }, 8, ["disabled"]),
                            _createVNode(_component_v_icon, {
                              disabled: 
                                        _ctx.reviewed === -1 ||
                                        !_ctx.isEnableReview ||
                                        !_ctx.validated ||
                                        _ctx.loading ||
                                        _ctx.dataLoading
                                    ,
                              size: "small",
                              icon: "$fa-thumbs-down",
                              color: "primary",
                              class: "mx-1",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => {
                                        _ctx.reviewed = -1;
                                        _ctx.validateAuditCheckResult('REVIEW');
                                    })
                            }, null, 8, ["disabled"]),
                            _cache[46] || (_cache[46] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1))
                          ], 64))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn_prev, _mergeProps(props, {
                            disabled: !_ctx.previousControl,
                            onClick: _cache[7] || (_cache[7] = ($event: any) => {
                                            _ctx.reviewed = 0;
                                            _ctx.openChat = false;
                                            _ctx.goToPreviousControl();
                                        })
                          }), null, 16, ["disabled"])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_2, " Contrôle précédent : " + _toDisplayString(_ctx.previousControl && _ctx.previousControl.title
                                            ? _ctx.previousControl.title
                                            : ""), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn_next, _mergeProps(props, {
                            onClick: _cache[8] || (_cache[8] = ($event: any) => {
                                            _ctx.reviewed = 0;
                                            _ctx.openChat = false;
                                            _ctx.goToNextControl();
                                        }),
                            disabled: !_ctx.nextControl
                          }), null, 16, ["disabled"])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, " Contrôle suivant : " + _toDisplayString(_ctx.nextControl && _ctx.nextControl.title ? _ctx.nextControl.title : ""), 1)
                        ]),
                        _: 1
                      }),
                      _cache[51] || (_cache[51] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1)),
                      _createVNode(_component_v_menu, { "offset-y": "" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                            class: "mx-1",
                            color: "secondary"
                          }), null, 16)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, { nav: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, {
                                disabled: !_ctx.auditCheckResult || !_ctx.auditCheckResult.id,
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.deleteAuditCheckResult(_ctx.auditCheckResult.id)))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_icon, { size: "small" }, {
                                    default: _withCtx(() => _cache[48] || (_cache[48] = [
                                      _createTextVNode(" $oss-trash ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[47] || (_cache[47] = [
                                      _createTextVNode(" Supprimer les commentaires et les validations du contrôle ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["disabled"]),
                              _createVNode(_component_v_list_item, {
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.displayActivityDialog = true))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[50] || (_cache[50] = [
                                      _createTextVNode("$oss-activity")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[49] || (_cache[49] = [
                                      _createTextVNode("Afficher l'activité")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.loading || _ctx.dataLoading)
                ? (_openBlock(), _createBlock(_component_v_card, {
                    key: 0,
                    elevation: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, {
                        style: {"text-align":"center"},
                        class: "pa-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_progress_circular, {
                            size: 70,
                            width: 7,
                            color: "primary",
                            indeterminate: "",
                            style: {"margin":"24px"}
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.company)
                      ? (_openBlock(), _createBlock(_component_v_card_subtitle, {
                          key: 0,
                          class: "py-2 mb-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "auto",
                                  class: "d-flex align-center pr-8"
                                }, {
                                  default: _withCtx(() => [
                                    (!_ctx.company.incomeCategory)
                                      ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(_ctx.$t("settings.incomeCategory")) + " : à renseigner dans 'Mon dossier' ", 1))
                                      : (_openBlock(), _createElementBlock("h3", _hoisted_5, _toDisplayString(_ctx.$t("settings.incomeCategory")) + " : " + _toDisplayString(_ctx.$t("settings." + _ctx.company.incomeCategory)), 1))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "auto",
                                  class: "d-flex align-center pr-8"
                                }, {
                                  default: _withCtx(() => [
                                    (!_ctx.company.taxRegime)
                                      ? (_openBlock(), _createElementBlock("h3", _hoisted_6, _toDisplayString(_ctx.$t("settings.taxRegime")) + " : à renseigner dans 'Mon dossier' ", 1))
                                      : (_openBlock(), _createElementBlock("h3", _hoisted_7, _toDisplayString(_ctx.$t("settings.taxRegime")) + " : " + _toDisplayString(_ctx.$t("settings." + _ctx.company.taxRegime)), 1))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "auto",
                                  class: "d-flex align-center pr-8"
                                }, {
                                  default: _withCtx(() => [
                                    (!_ctx.company.vatOption)
                                      ? (_openBlock(), _createElementBlock("h3", _hoisted_8, _toDisplayString(_ctx.$t("settings.vatOption")) + " : à renseigner dans 'Mon dossier' ", 1))
                                      : (_openBlock(), _createElementBlock("h3", _hoisted_9, _toDisplayString(_ctx.$t("settings.vatOption")) + " : " + _toDisplayString(_ctx.$t("settings." + _ctx.company.vatOption)), 1))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "auto",
                                  class: "d-flex align-center"
                                }, {
                                  default: _withCtx(() => [
                                    (!_ctx.company.vatSystem)
                                      ? (_openBlock(), _createElementBlock("h3", _hoisted_10, _toDisplayString(_ctx.$t("settings.vatSystem")) + " : à renseigner dans 'Mon dossier' ", 1))
                                      : (_openBlock(), _createElementBlock("h3", _hoisted_11, _toDisplayString(_ctx.$t("settings.vatSystem")) + " : " + _toDisplayString(_ctx.$t("settings." + _ctx.company.vatSystem)), 1))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_spacer),
                                (!_ctx.hideControl)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      cols: "auto",
                                      class: "d-flex text-right align-center"
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_col, {
                                  cols: "auto",
                                  class: "d-flex text-center align-center",
                                  style: {"border-left":"1px #ededed solid"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_menu, { "offset-y": "" })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (
                            _ctx.gapsResumeTable &&
                            _ctx.gapsResumeTable[0] &&
                            _ctx.gapsResumeTable[0].errors &&
                            _ctx.gapsResumeTable[0].errors.someNotLetteredPayement &&
                            _ctx.gapsResumeTable[0].errors.someNotLetteredPayement.length
                        )
                      ? (_openBlock(), _createBlock(_component_v_alert, {
                          key: 1,
                          border: "start",
                          "border-color": "red",
                          class: "py-4 my-4 text-red"
                        }, {
                          default: _withCtx(() => [
                            _cache[52] || (_cache[52] = _createElementVNode("h3", { class: "text-start" }, " Les clients suivants comportent des écritures sans comptes de produits qui pourraient correspondre à des paiements non lettrés et qui faussent le tableau. ", -1)),
                            _cache[53] || (_cache[53] = _createElementVNode("h4", { class: "text-start" }, " Veuillez terminer les lettrages afin que les colonnes soient correctement renseignées: ", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gapsResumeTable[0].errors
                                    .someNotLetteredPayement, (notLettered, index) => {
                              return (_openBlock(), _createElementBlock("h4", _hoisted_12, "- " + _toDisplayString(notLettered), 1))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (
                            _ctx.gapsResumeTable &&
                            _ctx.gapsResumeTable[1] &&
                            _ctx.gapsResumeTable[1].errors &&
                            _ctx.gapsResumeTable[1].errors.declarationsWith4458x &&
                            _ctx.gapsResumeTable[1].errors.declarationsWith4458x.length
                        )
                      ? (_openBlock(), _createBlock(_component_v_alert, {
                          key: 2,
                          border: "start",
                          "border-color": "red",
                          class: "py-4 my-4 text-red"
                        }, {
                          default: _withCtx(() => [
                            _cache[54] || (_cache[54] = _createElementVNode("h3", { class: "text-start" }, " Le contrôle ne peut pas répartir par taux des lignes comptables passées dans les comptes génériques commençant par c/4458. ", -1)),
                            _cache[55] || (_cache[55] = _createElementVNode("h4", { class: "text-start" }, " Veuillez corriger les déclarations suivantes en utilisant des comptes de type \"445720\" ou \"445660\": ", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gapsResumeTable[1].errors.declarationsWith4458x, (decl) => {
                              return (_openBlock(), _createElementBlock("h4", _hoisted_13, "- " + _toDisplayString(_ctx.formatDate(decl.date)), 1))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.show471GL && !_ctx.hideControl)
                      ? (_openBlock(), _createBlock(_component_v_card, {
                          key: 3,
                          elevation: "0",
                          style: {"background-color":"white","border-radius":"25px"},
                          class: "pa-6 my-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "11",
                                  class: "ma-auto"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "auto" }, {
                                              default: _withCtx(() => _cache[56] || (_cache[56] = [
                                                _createElementVNode("h5", { class: "pl-4" }, " Ecritures en attente d'affectation dans les comptes 471 ", -1)
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "auto",
                                              class: "d-flex align-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_icon, {
                                                  color: "secondary",
                                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.snackbar2 = true)),
                                                  icon: "$oss-help",
                                                  size: "x-small"
                                                }),
                                                _createVNode(_component_v_snackbar, {
                                                  modelValue: _ctx.snackbar2,
                                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.snackbar2) = $event)),
                                                  "multi-line": "",
                                                  timeout: -1,
                                                  width: "70vw"
                                                }, {
                                                  actions: _withCtx(() => [
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$oss-close",
                                                      size: "small",
                                                      onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.snackbar2 = false), ["stop"])),
                                                      class: "white",
                                                      color: "white"
                                                    })
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _cache[57] || (_cache[57] = _createElementVNode("h3", { class: "py-1" }, " Si le type est \"Banque\", veuillez affecter les opérations bancaires en attente. ", -1)),
                                                    _cache[58] || (_cache[58] = _createElementVNode("h3", { class: "py-1" }, " Autrement, si le solde est nul, tout va bien ! Vous pouvez accéder au contrôle. ", -1))
                                                  ]),
                                                  _: 1
                                                }, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_spacer)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "1",
                                  class: "d-flex align-center px-0 justify-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "6" }),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "align-center pa-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn_icon, {
                                              icon: 
                                                _ctx.isItemExpanded('expand471')
                                                    ? '$fa-chevron-up'
                                                    : '$fa-chevron-down'
                                            ,
                                              onClick: _cache[14] || (_cache[14] = ($event: any) => (
                                                _ctx.addRemoveItemExpanded(
                                                    true,
                                                    'expand471',
                                                    'refreshGeneralLedger471',
                                                )
                                            )),
                                              style: {"width":"40px"},
                                              class: "d-inline px-2"
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_ctx.show471GL && _ctx.isItemExpanded('expand471'))
                              ? (_openBlock(), _createBlock(_component_v_card_subtitle, {
                                  class: "pa-0 mb-0",
                                  key: _ctx.refreshGeneralLedger471
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_GeneralLedger, {
                                      companyId: _ctx.companyId,
                                      accountingPeriodId: _ctx.accountingPeriodId,
                                      accountableAccountFilter: ['471'],
                                      inNm1: false,
                                      hideOptions: true,
                                      withoutLetteringIfHidedOptions: true,
                                      hideBodyAppend: true,
                                      refreshCount: _ctx.refreshGeneralLedger471
                                    }, null, 8, ["companyId", "accountingPeriodId", "refreshCount"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.accountingPeriod)
                      ? (_openBlock(), _createBlock(_component_v_card_subtitle, {
                          key: 4,
                          class: "py-2 mb-6"
                        }, {
                          default: _withCtx(() => _cache[59] || (_cache[59] = [
                            _createElementVNode("h4", null, "Aucune période sélectionnée", -1)
                          ])),
                          _: 1
                        }))
                      : (_ctx.isNotSubjectToVAT(_ctx.company.vatSystem))
                        ? (_openBlock(), _createBlock(_component_v_card_subtitle, {
                            key: 5,
                            class: "py-2 mb-6"
                          }, {
                            default: _withCtx(() => _cache[60] || (_cache[60] = [
                              _createElementVNode("h4", null, "Entreprise non soumise à la TVA", -1)
                            ])),
                            _: 1
                          }))
                        : (_ctx.accountingPeriod && _ctx.accountingPeriod.closed)
                          ? (_openBlock(), _createBlock(_component_v_card_subtitle, {
                              key: 6,
                              class: "py-2 mb-6"
                            }, {
                              default: _withCtx(() => _cache[61] || (_cache[61] = [
                                _createElementVNode("h4", { class: "yellow_custom--text" }, "Période Clôturée", -1)
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                    (!_ctx.hideControl)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                          _createVNode(_component_oss_data_table, {
                            headers: _ctx.gapsResumeTableFilteredHeaders0,
                            items: _ctx.gapsResumeTable,
                            dense: true,
                            loading: _ctx.loading,
                            "fixed-header": "",
                            "max-height": "60vh"
                          }, {
                            item: _withCtx(({ item: item0 }) => [
                              _createElementVNode("tr", {
                                onClick: ($event: any) => (
                                        _ctx.addRemoveItemExpanded(item0.expandable, item0.title, undefined)
                                    ),
                                style: _normalizeStyle(item0.style),
                                class: _normalizeClass(_ctx.differenceColorClass(item0, item0.title))
                              }, [
                                _createElementVNode("td", _hoisted_15, [
                                  (item0.expandable)
                                    ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.isItemExpanded(item0.title)
                                                    ? "$fa-chevron-up"
                                                    : "$fa-chevron-down"), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", _hoisted_16, [
                                  (item0.title)
                                    ? (_openBlock(), _createElementBlock("strong", _hoisted_17, _toDisplayString(item0.title), 1))
                                    : (_openBlock(), _createElementBlock("strong", _hoisted_18, "-")),
                                  (item0.help)
                                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                        key: 2,
                                        location: "bottom"
                                      }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_icon, _mergeProps({
                                            class: "pl-2",
                                            color: "secondary",
                                            icon: "$oss-help"
                                          }, props), null, 16)
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("div", {
                                            innerHTML: item0.help
                                          }, null, 8, _hoisted_19)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ]),
                                _cache[62] || (_cache[62] = _createElementVNode("td", {
                                  class: "text-right",
                                  style: {"width":"100px"}
                                }, null, -1)),
                                _createElementVNode("td", _hoisted_20, [
                                  (item0.HTsum)
                                    ? (_openBlock(), _createElementBlock("h4", _hoisted_21, _toDisplayString(_ctx.newCommonFormatCurrency(item0.HTsum, undefined)), 1))
                                    : (item0.HTsum === 0)
                                      ? (_openBlock(), _createElementBlock("h4", _hoisted_22, "0 €"))
                                      : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", _hoisted_23, [
                                  (item0.VATsum)
                                    ? (_openBlock(), _createElementBlock("h4", _hoisted_24, _toDisplayString(_ctx.newCommonFormatCurrency(item0.VATsum, undefined)), 1))
                                    : (item0.VATsum === 0)
                                      ? (_openBlock(), _createElementBlock("h4", _hoisted_25, "0 €"))
                                      : _createCommentVNode("", true)
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnsToShow, (key, index) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    key: index,
                                    class: "text-right",
                                    style: {"width":"100px","padding-right":"37px"}
                                  }, [
                                    (item0[key])
                                      ? (_openBlock(), _createElementBlock("h5", _hoisted_26, _toDisplayString(_ctx.newCommonFormatCurrency(item0[key], undefined)), 1))
                                      : (item0[key] === 0)
                                        ? (_openBlock(), _createElementBlock("h5", _hoisted_27, "0 €"))
                                        : _createCommentVNode("", true)
                                  ]))
                                }), 128)),
                                _cache[63] || (_cache[63] = _createElementVNode("td", {
                                  style: {"width":"35px"},
                                  class: "px-0"
                                }, null, -1))
                              ], 14, _hoisted_14),
                              (_ctx.isItemExpanded(item0.title))
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                                    _createElementVNode("td", _hoisted_29, [
                                      (item0.tables)
                                        ? (_openBlock(), _createBlock(_component_oss_data_table, {
                                            key: 0,
                                            headers: _ctx.gapsResumeTableFilteredHeaders0,
                                            items: item0.tables,
                                            dense: true,
                                            hideDefaultHeader: true,
                                            "max-height": "60vh"
                                          }, {
                                            "no-data": _withCtx(() => _cache[64] || (_cache[64] = [
                                              _createTextVNode("Aucune anomalie")
                                            ])),
                                            item: _withCtx(({ item: item1 }) => [
                                              _createElementVNode("tr", {
                                                onClick: ($event: any) => (
                                                            _ctx.addRemoveItemExpanded(
                                                                item1.expandable,
                                                                item1.title,
                                                                undefined,
                                                            )
                                                        ),
                                                style: {"background":"#fef8ee"},
                                                class: _normalizeClass(_ctx.differenceColorClass(item1))
                                              }, [
                                                _createElementVNode("td", _hoisted_31, [
                                                  (item1.expandable)
                                                    ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(_ctx.isItemExpanded(item1.title)
                                                                        ? "$fa-chevron-up"
                                                                        : "$fa-chevron-down"), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("td", _hoisted_32, [
                                                  (item1.title)
                                                    ? (_openBlock(), _createElementBlock("strong", _hoisted_33, _toDisplayString(item1.title), 1))
                                                    : (_openBlock(), _createElementBlock("strong", _hoisted_34, "-")),
                                                  (item1.help)
                                                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                        key: 2,
                                                        location: "bottom"
                                                      }, {
                                                        activator: _withCtx(({ props }) => [
                                                          _createVNode(_component_v_icon, _mergeProps({
                                                            class: "pl-2",
                                                            color: "secondary",
                                                            icon: "$oss-help"
                                                          }, props), null, 16)
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createElementVNode("div", {
                                                            innerHTML: item1.help
                                                          }, null, 8, _hoisted_35)
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("td", _hoisted_36, [
                                                  (item1.TTCsum)
                                                    ? (_openBlock(), _createElementBlock("h5", _hoisted_37, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                        item1.TTCsum,
                                                                        undefined,
                                                                    )), 1))
                                                    : (_openBlock(), _createElementBlock("h5", _hoisted_38, "0 €"))
                                                ]),
                                                _createElementVNode("td", _hoisted_39, [
                                                  (item1.HTsum)
                                                    ? (_openBlock(), _createElementBlock("h5", _hoisted_40, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                        item1.HTsum,
                                                                        undefined,
                                                                    )), 1))
                                                    : (_openBlock(), _createElementBlock("h5", _hoisted_41, "0 €"))
                                                ]),
                                                _createElementVNode("td", _hoisted_42, [
                                                  (item1.VATsum)
                                                    ? (_openBlock(), _createElementBlock("h5", _hoisted_43, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                        item1.VATsum,
                                                                        undefined,
                                                                    )), 1))
                                                    : (_openBlock(), _createElementBlock("h5", _hoisted_44, "0 €"))
                                                ]),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnsToShow, (key, index) => {
                                                  return (_openBlock(), _createElementBlock("td", {
                                                    key: index,
                                                    class: "text-right",
                                                    style: {"width":"100px"}
                                                  }, [
                                                    (item1[key])
                                                      ? (_openBlock(), _createElementBlock("h5", _hoisted_45, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                        item1[key],
                                                                        undefined,
                                                                    )), 1))
                                                      : (_openBlock(), _createElementBlock("h5", _hoisted_46, "0 €"))
                                                  ]))
                                                }), 128)),
                                                _cache[65] || (_cache[65] = _createElementVNode("td", {
                                                  style: {"width":"24px"},
                                                  class: "px-0"
                                                }, null, -1))
                                              ], 10, _hoisted_30),
                                              (_ctx.isItemExpanded(item1.title))
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_47, [
                                                    _createElementVNode("td", _hoisted_48, [
                                                      (item1.table)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _createVNode(_component_oss_data_table, {
                                                              headers: 
                                                                        _ctx.gapsResumeTableFilteredHeaders0
                                                                    ,
                                                              items: item1.table,
                                                              dense: true,
                                                              loading: _ctx.loading,
                                                              hideDefaultHeader: "true",
                                                              "max-height": "60vh"
                                                            }, {
                                                              item: _withCtx(({ item: item2 }) => [
                                                                _createElementVNode("tr", {
                                                                  onClick: ($event: any) => (
                                                                                _ctx.addRemoveItemExpanded(
                                                                                    item2.expandable,
                                                                                    item2.title,
                                                                                    undefined,
                                                                                )
                                                                            ),
                                                                  class: _normalizeClass(
                                                                                _ctx.differenceColorClass(
                                                                                    item2,
                                                                                )
                                                                            )
                                                                }, [
                                                                  _createElementVNode("td", _hoisted_50, [
                                                                    (
                                                                                        item2.expandable
                                                                                    )
                                                                      ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                                                                          default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(_ctx.isItemExpanded(
                                                                                            item2.title,
                                                                                        )
                                                                                            ? "$fa-chevron-up"
                                                                                            : "$fa-chevron-down"), 1)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1024))
                                                                      : _createCommentVNode("", true)
                                                                  ]),
                                                                  _createElementVNode("td", {
                                                                    class: _normalizeClass(["text-left", 
                                                                                    _ctx.differenceColorClass(
                                                                                        item2,
                                                                                    )
                                                                                ]),
                                                                    style: {"width":"300px"}
                                                                  }, [
                                                                    (item2.title)
                                                                      ? (_openBlock(), _createElementBlock("strong", _hoisted_51, _toDisplayString(item2.title), 1))
                                                                      : (_openBlock(), _createElementBlock("strong", _hoisted_52, "-"))
                                                                  ], 2),
                                                                  _createElementVNode("td", _hoisted_53, [
                                                                    (item2.TTCsum)
                                                                      ? (_openBlock(), _createElementBlock("h5", _hoisted_54, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                            item2.TTCsum,
                                                                                            undefined,
                                                                                        )), 1))
                                                                      : (_openBlock(), _createElementBlock("h5", _hoisted_55, " 0 € "))
                                                                  ]),
                                                                  _createElementVNode("td", _hoisted_56, [
                                                                    (item2.HTsum)
                                                                      ? (_openBlock(), _createElementBlock("h5", _hoisted_57, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                            item2.HTsum,
                                                                                            undefined,
                                                                                        )), 1))
                                                                      : (_openBlock(), _createElementBlock("h5", _hoisted_58, " 0 € "))
                                                                  ]),
                                                                  _createElementVNode("td", _hoisted_59, [
                                                                    (item2.VATsum)
                                                                      ? (_openBlock(), _createElementBlock("h5", _hoisted_60, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                            item2.VATsum,
                                                                                            undefined,
                                                                                        )), 1))
                                                                      : (_openBlock(), _createElementBlock("h5", _hoisted_61, " 0 € "))
                                                                  ]),
                                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnsToShow, (key, index) => {
                                                                    return (_openBlock(), _createElementBlock("td", {
                                                                      class: "text-right",
                                                                      style: {"width":"100px"},
                                                                      key: index
                                                                    }, [
                                                                      (
                                                                                        item2.HTtextfield &&
                                                                                        key.startsWith(
                                                                                            'HT',
                                                                                        )
                                                                                    )
                                                                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                                            key: 0,
                                                                            location: "bottom"
                                                                          }, {
                                                                            activator: _withCtx(({
                                                                                            props,
                                                                                        }) => [
                                                                              _createVNode(_component_oss_text_field_filled, _mergeProps({ ref_for: true }, 
                                                                                                props
                                                                                            , {
                                                                                modelValue: 
                                                                                                item2[
                                                                                                    key
                                                                                                ]
                                                                                            ,
                                                                                "onUpdate:modelValue": [($event: any) => ((
                                                                                                item2[
                                                                                                    key
                                                                                                ]
                                                                                            ) = $event), ($event: any) => (
                                                                                                _ctx.modifyManualAmount(
                                                                                                    _ctx.acrAmounts,
                                                                                                    item2,
                                                                                                    key,
                                                                                                    'corrections',
                                                                                                    item1.generalLedgerText,
                                                                                                    _ctx.gapsResumeTable,
                                                                                                    item1.title,
                                                                                                )
                                                                                            )],
                                                                                "hide-details": 
                                                                                                true
                                                                                            ,
                                                                                "single-line": "",
                                                                                dense: ""
                                                                              }), null, 16, ["modelValue", "onUpdate:modelValue"])
                                                                            ]),
                                                                            default: _withCtx(() => [
                                                                              _cache[66] || (_cache[66] = _createElementVNode("span", null, "Même signe que le total", -1))
                                                                            ]),
                                                                            _: 2
                                                                          }, 1024))
                                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                            (
                                                                                            item2[key]
                                                                                        )
                                                                              ? (_openBlock(), _createElementBlock("h5", _hoisted_62, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                                item2[
                                                                                                    key
                                                                                                ],
                                                                                                undefined,
                                                                                            )), 1))
                                                                              : (_openBlock(), _createElementBlock("h5", _hoisted_63, " 0 € "))
                                                                          ], 64))
                                                                    ]))
                                                                  }), 128)),
                                                                  _cache[67] || (_cache[67] = _createElementVNode("td", {
                                                                    style: {"width":"12px"},
                                                                    class: "px-0"
                                                                  }, null, -1))
                                                                ], 10, _hoisted_49),
                                                                (
                                                                                _ctx.isItemExpanded(
                                                                                    item2.title,
                                                                                )
                                                                            )
                                                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_64, [
                                                                      _createElementVNode("td", _hoisted_65, [
                                                                        (item2.table)
                                                                          ? (_openBlock(), _createBlock(_component_oss_data_table, {
                                                                              key: 0,
                                                                              headers: 
                                                                                            _ctx.gapsResumeTableFilteredHeaders0
                                                                                        ,
                                                                              items: 
                                                                                            item2.table
                                                                                        ,
                                                                              dense: true,
                                                                              loading: 
                                                                                            _ctx.loading
                                                                                        ,
                                                                              hideDefaultHeader: "true",
                                                                              "max-height": "60vh"
                                                                            }, {
                                                                              item: _withCtx(({
                                                                                                item: item3,
                                                                                            }) => [
                                                                                _createElementVNode("tr", {
                                                                                  class: _normalizeClass(
                                                                                                    _ctx.differenceColorClass(
                                                                                                        item3,
                                                                                                    )
                                                                                                )
                                                                                }, [
                                                                                  _cache[69] || (_cache[69] = _createElementVNode("td", {
                                                                                    class: "text-center",
                                                                                    style: {"width":"50px"}
                                                                                  }, null, -1)),
                                                                                  _createElementVNode("td", _hoisted_66, [
                                                                                    (
                                                                                                            item3.title
                                                                                                        )
                                                                                      ? (_openBlock(), _createElementBlock("p", {
                                                                                          key: 0,
                                                                                          style: _normalizeStyle(
                                                                                                            _ctx.pStyle
                                                                                                        ),
                                                                                          class: _normalizeClass(
                                                                                                            _ctx.differenceColorClass(
                                                                                                                item3,
                                                                                                            )
                                                                                                        )
                                                                                        }, _toDisplayString(item3.title), 7))
                                                                                      : (_openBlock(), _createElementBlock("p", {
                                                                                          key: 1,
                                                                                          style: _normalizeStyle(
                                                                                                            _ctx.pStyle
                                                                                                        )
                                                                                        }, " - ", 4))
                                                                                  ]),
                                                                                  _createElementVNode("td", {
                                                                                    class: _normalizeClass(["text-right", 
                                                                                                        _ctx.differenceColorClass(
                                                                                                            item3,
                                                                                                        )
                                                                                                    ]),
                                                                                    style: {"width":"100px"}
                                                                                  }, [
                                                                                    (
                                                                                                            item3.TTCsum
                                                                                                        )
                                                                                      ? (_openBlock(), _createElementBlock("p", {
                                                                                          key: 0,
                                                                                          style: _normalizeStyle(
                                                                                                            _ctx.pStyle
                                                                                                        )
                                                                                        }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                                                item3.TTCsum,
                                                                                                                undefined,
                                                                                                            )), 5))
                                                                                      : (_openBlock(), _createElementBlock("p", {
                                                                                          key: 1,
                                                                                          style: _normalizeStyle(
                                                                                                            _ctx.pStyle
                                                                                                        ),
                                                                                          class: _normalizeClass(
                                                                                                            _ctx.differenceColorClass(
                                                                                                                item3,
                                                                                                            )
                                                                                                        )
                                                                                        }, " 0 € ", 6))
                                                                                  ], 2),
                                                                                  _createElementVNode("td", _hoisted_67, [
                                                                                    (
                                                                                                            item3.HTsum
                                                                                                        )
                                                                                      ? (_openBlock(), _createElementBlock("p", {
                                                                                          key: 0,
                                                                                          style: _normalizeStyle(
                                                                                                            _ctx.pStyle
                                                                                                        ),
                                                                                          class: _normalizeClass(
                                                                                                            _ctx.differenceColorClass(
                                                                                                                item3,
                                                                                                            )
                                                                                                        )
                                                                                        }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                                                item3.HTsum,
                                                                                                                undefined,
                                                                                                            )), 7))
                                                                                      : (_openBlock(), _createElementBlock("p", {
                                                                                          key: 1,
                                                                                          style: _normalizeStyle(
                                                                                                            _ctx.pStyle
                                                                                                        ),
                                                                                          class: _normalizeClass(
                                                                                                            _ctx.differenceColorClass(
                                                                                                                item3,
                                                                                                            )
                                                                                                        )
                                                                                        }, " 0 € ", 6))
                                                                                  ]),
                                                                                  _createElementVNode("td", _hoisted_68, [
                                                                                    (
                                                                                                            item3.VATsum
                                                                                                        )
                                                                                      ? (_openBlock(), _createElementBlock("p", {
                                                                                          key: 0,
                                                                                          style: _normalizeStyle(
                                                                                                            _ctx.pStyle
                                                                                                        ),
                                                                                          class: _normalizeClass(
                                                                                                            _ctx.differenceColorClass(
                                                                                                                item3,
                                                                                                            )
                                                                                                        )
                                                                                        }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                                                item3.VATsum,
                                                                                                                undefined,
                                                                                                            )), 7))
                                                                                      : (_openBlock(), _createElementBlock("p", {
                                                                                          key: 1,
                                                                                          style: _normalizeStyle(
                                                                                                            _ctx.pStyle
                                                                                                        ),
                                                                                          class: _normalizeClass(
                                                                                                            _ctx.differenceColorClass(
                                                                                                                item3,
                                                                                                            )
                                                                                                        )
                                                                                        }, " 0 € ", 6))
                                                                                  ]),
                                                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnsToShow, (key, index) => {
                                                                                    return (_openBlock(), _createElementBlock("td", {
                                                                                      class: "text-right",
                                                                                      style: {"width":"100px"},
                                                                                      key: 
                                                                                                        index
                                                                                                    
                                                                                    }, [
                                                                                      (
                                                                                                            item3.HTtextfield &&
                                                                                                            key.startsWith(
                                                                                                                'HT',
                                                                                                            )
                                                                                                        )
                                                                                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                                                            key: 0,
                                                                                            location: "bottom"
                                                                                          }, {
                                                                                            activator: _withCtx(({
                                                                                                                props,
                                                                                                            }) => [
                                                                                              _createVNode(_component_oss_text_field_filled, _mergeProps({ ref_for: true }, 
                                                                                                                    props
                                                                                                                , {
                                                                                                modelValue: 
                                                                                                                    item3[
                                                                                                                        key
                                                                                                                    ]
                                                                                                                ,
                                                                                                "onUpdate:modelValue": [($event: any) => ((
                                                                                                                    item3[
                                                                                                                        key
                                                                                                                    ]
                                                                                                                ) = $event), ($event: any) => (
                                                                                                                    _ctx.modifyManualAmount(
                                                                                                                        _ctx.acrAmounts,
                                                                                                                        item3,
                                                                                                                        key,
                                                                                                                        'corrections',
                                                                                                                        item1.generalLedgerText,
                                                                                                                        _ctx.gapsResumeTable,
                                                                                                                        item1.title,
                                                                                                                    )
                                                                                                                )],
                                                                                                "hide-details": 
                                                                                                                    true
                                                                                                                ,
                                                                                                "single-line": "",
                                                                                                dense: ""
                                                                                              }), null, 16, ["modelValue", "onUpdate:modelValue"])
                                                                                            ]),
                                                                                            default: _withCtx(() => [
                                                                                              _cache[68] || (_cache[68] = _createElementVNode("span", null, "Même signe que le total", -1))
                                                                                            ]),
                                                                                            _: 2
                                                                                          }, 1024))
                                                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                                            (
                                                                                                                item3[
                                                                                                                    key
                                                                                                                ]
                                                                                                            )
                                                                                              ? (_openBlock(), _createElementBlock("h5", _hoisted_69, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                                                    item3[
                                                                                                                        key
                                                                                                                    ],
                                                                                                                    undefined,
                                                                                                                )), 1))
                                                                                              : (_openBlock(), _createElementBlock("h5", _hoisted_70, " 0 € "))
                                                                                          ], 64))
                                                                                    ]))
                                                                                  }), 128)),
                                                                                  _cache[70] || (_cache[70] = _createElementVNode("td", {
                                                                                    style: {"width":"1px"},
                                                                                    class: "px-0"
                                                                                  }, null, -1))
                                                                                ], 2)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1032, ["headers", "items", "loading"]))
                                                                          : _createCommentVNode("", true)
                                                                      ])
                                                                    ]))
                                                                  : _createCommentVNode("", true)
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["headers", "items", "loading"]),
                                                            _createVNode(_component_v_card, {
                                                              style: {"background":"#F4F4F4"},
                                                              elevation: "0"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_card_text, {
                                                                  onClick: ($event: any) => (
                                                                            _ctx.addRemoveItemExpanded(
                                                                                item1.expandable,
                                                                                item1.generalLedgerText,
                                                                                'refreshGeneralLedger_general',
                                                                            )
                                                                        ),
                                                                  class: "pl-6 d-flex align-center"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_icon, null, {
                                                                      default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(_ctx.isItemExpanded(
                                                                                    item1.generalLedgerText,
                                                                                )
                                                                                    ? "$fa-chevron-up"
                                                                                    : "$fa-chevron-down"), 1)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1024),
                                                                    _createElementVNode("h3", _hoisted_71, _toDisplayString(item1.generalLedgerText), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["onClick"]),
                                                                (
                                                                            _ctx.isItemExpanded(
                                                                                item1.generalLedgerText,
                                                                            )
                                                                        )
                                                                  ? (_openBlock(), _createBlock(_component_v_card_text, {
                                                                      key: 0,
                                                                      transition: "expand",
                                                                      class: "px-0 pt-0 pb-2"
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_v_card, { style: {"background-color":"white","border-radius":"25px"} }, {
                                                                          default: _withCtx(() => [
                                                                            (_openBlock(), _createBlock(_component_v_row, {
                                                                              "no-gutters": "",
                                                                              key: 
                                                                                    _ctx.refreshGeneralLedger_general
                                                                                
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_col, { cols: "12" }, {
                                                                                  default: _withCtx(() => [
                                                                                    _createVNode(_component_GeneralLedger, {
                                                                                      companyId: 
                                                                                            _ctx.companyId
                                                                                        ,
                                                                                      accountingPeriodId: 
                                                                                            item1.periodId
                                                                                        ,
                                                                                      accountableAccountFilter: 
                                                                                            item1.accountableAccounts
                                                                                        ,
                                                                                      inNm1: false,
                                                                                      hideOptions: 
                                                                                            true
                                                                                        ,
                                                                                      withoutLetteringIfHidedOptions: 
                                                                                            true
                                                                                        ,
                                                                                      refreshCount: 
                                                                                            _ctx.refreshGeneralLedger_general
                                                                                        
                                                                                    }, null, 8, ["companyId", "accountingPeriodId", "accountableAccountFilter", "refreshCount"])
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1024)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024)),
                                                                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                                                                  default: _withCtx(() => [
                                                                                    _createVNode(_component_v_card_title, { style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"} }, {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_v_spacer)
                                                                                      ]),
                                                                                      _: 1
                                                                                    })
                                                                                  ]),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              _: 1
                                                                            })
                                                                          ]),
                                                                          _: 2
                                                                        }, 1024)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1024))
                                                                  : _createCommentVNode("", true)
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            (item1.generalLedgerTextAux)
                                                              ? (_openBlock(), _createBlock(_component_v_card, {
                                                                  key: 0,
                                                                  style: {"background":"#F4F4F4"},
                                                                  elevation: "0"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_card_text, {
                                                                      onClick: ($event: any) => (
                                                                            _ctx.addRemoveItemExpanded(
                                                                                item1.expandable,
                                                                                item1.generalLedgerTextAux,
                                                                                'refreshGeneralLedger_aux',
                                                                            )
                                                                        ),
                                                                      class: "pl-6 d-flex align-center"
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        (item1.expandable)
                                                                          ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                                                                              default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(_ctx.isItemExpanded(
                                                                                    item1.generalLedgerTextAux,
                                                                                )
                                                                                    ? "$fa-chevron-up"
                                                                                    : "$fa-chevron-down"), 1)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024))
                                                                          : _createCommentVNode("", true),
                                                                        _createElementVNode("h3", _hoisted_72, _toDisplayString(item1.generalLedgerTextAux), 1)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1032, ["onClick"]),
                                                                    (
                                                                            _ctx.isItemExpanded(
                                                                                item1.generalLedgerTextAux,
                                                                            )
                                                                        )
                                                                      ? (_openBlock(), _createBlock(_component_v_card_text, {
                                                                          key: 0,
                                                                          transition: "expand",
                                                                          class: "px-0 pt-0 pb-2"
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createVNode(_component_v_card, { style: {"background-color":"white","border-radius":"25px"} }, {
                                                                              default: _withCtx(() => [
                                                                                (_openBlock(), _createBlock(_component_v_row, {
                                                                                  "no-gutters": "",
                                                                                  key: 
                                                                                    _ctx.refreshGeneralLedger_aux
                                                                                
                                                                                }, {
                                                                                  default: _withCtx(() => [
                                                                                    _createVNode(_component_v_col, { cols: "12" }, {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_GeneralLedger, {
                                                                                          companyId: 
                                                                                            _ctx.companyId
                                                                                        ,
                                                                                          accountingPeriodId: 
                                                                                            item1.periodId
                                                                                        ,
                                                                                          inNm1: false,
                                                                                          hideOptions: 
                                                                                            true
                                                                                        ,
                                                                                          withoutLetteringIfHidedOptions: 
                                                                                            true
                                                                                        ,
                                                                                          inThirdParty: 
                                                                                            true
                                                                                        ,
                                                                                          thirdPartyType: 
                                                                                            item1.thirdPartyType
                                                                                        ,
                                                                                          showThirdParty: 
                                                                                            true
                                                                                        ,
                                                                                          refreshCount: 
                                                                                            _ctx.refreshGeneralLedger_aux
                                                                                        
                                                                                        }, null, 8, ["companyId", "accountingPeriodId", "thirdPartyType", "refreshCount"])
                                                                                      ]),
                                                                                      _: 2
                                                                                    }, 1024)
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1024)),
                                                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                                                  default: _withCtx(() => [
                                                                                    _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_v_card_title, { style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"} }, {
                                                                                          default: _withCtx(() => [
                                                                                            _createVNode(_component_v_spacer)
                                                                                          ]),
                                                                                          _: 1
                                                                                        })
                                                                                      ]),
                                                                                      _: 1
                                                                                    })
                                                                                  ]),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1024))
                                                                      : _createCommentVNode("", true)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024))
                                                              : _createCommentVNode("", true)
                                                          ], 64))
                                                        : _createCommentVNode("", true)
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1032, ["headers", "items"]))
                                        : _createCommentVNode("", true),
                                      (item0.table)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createVNode(_component_oss_data_table, {
                                              headers: _ctx.gapsResumeTableFilteredHeaders0,
                                              items: item0.table,
                                              dense: true,
                                              hideDefaultHeader: true,
                                              "max-height": "60vh"
                                            }, {
                                              "no-data": _withCtx(() => _cache[71] || (_cache[71] = [
                                                _createTextVNode("Aucune anomalie")
                                              ])),
                                              item: _withCtx(({ item: itemVAT }) => [
                                                _createElementVNode("tr", {
                                                  style: _normalizeStyle(itemVAT.style),
                                                  class: _normalizeClass(
                                                            _ctx.differenceColorClass(itemVAT, itemVAT.month)
                                                        ),
                                                  onClick: ($event: any) => (
                                                            _ctx.addRemoveItemExpanded(
                                                                itemVAT.expandable,
                                                                itemVAT.month,
                                                                undefined,
                                                            )
                                                        )
                                                }, [
                                                  _createElementVNode("td", _hoisted_74, [
                                                    (itemVAT.expandable)
                                                      ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.isItemExpanded(itemVAT.month)
                                                                        ? "$fa-chevron-up"
                                                                        : "$fa-chevron-down"), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _createElementVNode("td", _hoisted_75, [
                                                    (itemVAT.documentId)
                                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                                          key: 0,
                                                          color: "primary",
                                                          icon: "$remove_red_eye",
                                                          onClick: ($event: any) => (
                                                                    _ctx.openDocument(itemVAT.documentId)
                                                                )
                                                        }, null, 8, ["onClick"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _createElementVNode("td", _hoisted_76, [
                                                    (itemVAT.month)
                                                      ? (_openBlock(), _createElementBlock("b", _hoisted_77, _toDisplayString(itemVAT.month), 1))
                                                      : (_openBlock(), _createElementBlock("b", _hoisted_78))
                                                  ]),
                                                  _cache[73] || (_cache[73] = _createElementVNode("td", {
                                                    class: "text-right",
                                                    style: {"width":"100px"}
                                                  }, null, -1)),
                                                  _createElementVNode("td", _hoisted_79, [
                                                    (itemVAT.HTsum)
                                                      ? (_openBlock(), _createElementBlock("b", _hoisted_80, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    itemVAT.HTsum,
                                                                    undefined,
                                                                )), 1))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _createElementVNode("td", _hoisted_81, [
                                                    (itemVAT.VATsum)
                                                      ? (_openBlock(), _createElementBlock("b", _hoisted_82, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    itemVAT.VATsum,
                                                                    undefined,
                                                                )), 1))
                                                      : (_openBlock(), _createElementBlock("b", _hoisted_83, "-"))
                                                  ]),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnsToShow, (key, index) => {
                                                    return (_openBlock(), _createElementBlock("td", {
                                                      key: index,
                                                      class: "text-right",
                                                      style: {"width":"100px"}
                                                    }, [
                                                      (_ctx.selectedOptionnalsColumns.length)
                                                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                            key: 0,
                                                            location: "bottom"
                                                          }, {
                                                            activator: _withCtx(({ props }) => [
                                                              _createVNode(_component_oss_text_field_filled, _mergeProps({ ref_for: true }, props, {
                                                                modelValue: itemVAT[key],
                                                                "onUpdate:modelValue": [($event: any) => ((itemVAT[key]) = $event), ($event: any) => (
                                                                            _ctx.modifyManualAmount(
                                                                                _ctx.acrAmounts,
                                                                                itemVAT,
                                                                                key,
                                                                                'VAT',
                                                                                item0.title,
                                                                                _ctx.gapsResumeTable,
                                                                            )
                                                                        )],
                                                                outlined: "",
                                                                dense: "",
                                                                "hide-details": "",
                                                                style: {"width":"100px"},
                                                                onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
                                                              }), null, 16, ["modelValue", "onUpdate:modelValue"])
                                                            ]),
                                                            default: _withCtx(() => [
                                                              _cache[72] || (_cache[72] = _createElementVNode("span", null, "Même signe que le total", -1))
                                                            ]),
                                                            _: 2
                                                          }, 1024))
                                                        : (itemVAT[key])
                                                          ? (_openBlock(), _createElementBlock("h5", _hoisted_84, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                        itemVAT[key],
                                                                        undefined,
                                                                    )), 1))
                                                          : (_openBlock(), _createElementBlock("h5", _hoisted_85, "0 €"))
                                                    ]))
                                                  }), 128)),
                                                  _cache[74] || (_cache[74] = _createElementVNode("td", {
                                                    style: {"width":"30px"},
                                                    class: "px-0"
                                                  }, null, -1))
                                                ], 14, _hoisted_73),
                                                (_ctx.isItemExpanded(itemVAT.month))
                                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_86, [
                                                      _createElementVNode("td", _hoisted_87, [
                                                        (itemVAT.tables)
                                                          ? (_openBlock(), _createBlock(_component_oss_data_table, {
                                                              key: 0,
                                                              headers: 
                                                                        _ctx.gapsResumeTableFilteredHeaders0
                                                                    ,
                                                              items: itemVAT.tables,
                                                              dense: true,
                                                              loading: _ctx.loading,
                                                              hideDefaultHeader: "true",
                                                              "max-height": "60vh"
                                                            }, {
                                                              item: _withCtx(({ item: itemVAT2 }) => [
                                                                _createElementVNode("tr", {
                                                                  class: _normalizeClass(
                                                                                _ctx.differenceColorClass(
                                                                                    itemVAT2,
                                                                                )
                                                                            )
                                                                }, [
                                                                  _cache[76] || (_cache[76] = _createElementVNode("td", {
                                                                    class: "text-center",
                                                                    style: {"width":"50px"}
                                                                  }, null, -1)),
                                                                  _cache[77] || (_cache[77] = _createElementVNode("td", {
                                                                    class: "text-center",
                                                                    style: {"width":"50px"}
                                                                  }, null, -1)),
                                                                  _createElementVNode("td", _hoisted_88, _toDisplayString(itemVAT2.title || "") + " - " + _toDisplayString(itemVAT2.subtitle ||
                                                                                    ""), 1),
                                                                  _cache[78] || (_cache[78] = _createElementVNode("td", {
                                                                    class: "text-right",
                                                                    style: {"width":"100px"}
                                                                  }, null, -1)),
                                                                  _createElementVNode("td", _hoisted_89, [
                                                                    (
                                                                                        itemVAT2.HTsum
                                                                                    )
                                                                      ? (_openBlock(), _createElementBlock("b", _hoisted_90, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                            itemVAT2.HTsum,
                                                                                            undefined,
                                                                                        )), 1))
                                                                      : _createCommentVNode("", true)
                                                                  ]),
                                                                  _createElementVNode("td", _hoisted_91, [
                                                                    (
                                                                                        itemVAT2.VATsum
                                                                                    )
                                                                      ? (_openBlock(), _createElementBlock("b", _hoisted_92, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                            itemVAT2.VATsum,
                                                                                            undefined,
                                                                                        )), 1))
                                                                      : (_openBlock(), _createElementBlock("b", _hoisted_93, "-"))
                                                                  ]),
                                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnsToShow, (key, index) => {
                                                                    return (_openBlock(), _createElementBlock("td", {
                                                                      key: index,
                                                                      class: "text-right",
                                                                      style: {"width":"100px"}
                                                                    }, [
                                                                      (
                                                                                        (itemVAT2.HTtextfield &&
                                                                                            key.startsWith(
                                                                                                'HT',
                                                                                            )) ||
                                                                                        (itemVAT2.VATtextfield &&
                                                                                            key.startsWith(
                                                                                                'VAT',
                                                                                            ))
                                                                                    )
                                                                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                                            key: 0,
                                                                            location: "bottom"
                                                                          }, {
                                                                            activator: _withCtx(({
                                                                                            props,
                                                                                        }) => [
                                                                              _createVNode(_component_oss_text_field_filled, _mergeProps({ ref_for: true }, 
                                                                                                props
                                                                                            , {
                                                                                modelValue: 
                                                                                                itemVAT2[
                                                                                                    key
                                                                                                ]
                                                                                            ,
                                                                                "onUpdate:modelValue": [($event: any) => ((
                                                                                                itemVAT2[
                                                                                                    key
                                                                                                ]
                                                                                            ) = $event), ($event: any) => (
                                                                                                _ctx.modifyManualAmount(
                                                                                                    _ctx.acrAmounts,
                                                                                                    itemVAT2,
                                                                                                    key,
                                                                                                    'VAT',
                                                                                                    _ctx.gapsResumeTable[1]
                                                                                                        .generalLedgerText,
                                                                                                    _ctx.gapsResumeTable,
                                                                                                    itemVAT.month,
                                                                                                )
                                                                                            )],
                                                                                outlined: "",
                                                                                dense: "",
                                                                                "hide-details": "",
                                                                                style: {"width":"100px"},
                                                                                onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
                                                                              }), null, 16, ["modelValue", "onUpdate:modelValue"])
                                                                            ]),
                                                                            default: _withCtx(() => [
                                                                              _cache[75] || (_cache[75] = _createElementVNode("span", null, "Même signe que le total", -1))
                                                                            ]),
                                                                            _: 2
                                                                          }, 1024))
                                                                        : (
                                                                                        itemVAT2[key]
                                                                                    )
                                                                          ? (_openBlock(), _createElementBlock("h5", _hoisted_94, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                            itemVAT2[
                                                                                                key
                                                                                            ],
                                                                                            undefined,
                                                                                        )), 1))
                                                                          : (_openBlock(), _createElementBlock("h5", _hoisted_95, " 0 € "))
                                                                    ]))
                                                                  }), 128))
                                                                ], 2)
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["headers", "items", "loading"]))
                                                          : _createCommentVNode("", true)
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1032, ["headers", "items"]),
                                            _createVNode(_component_v_card, {
                                              style: {"background":"#F4F4F4"},
                                              elevation: "0"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_text, {
                                                  onClick: ($event: any) => (
                                                        _ctx.addRemoveItemExpanded(
                                                            true,
                                                            item0.generalLedgerText,
                                                            'refreshGeneralLedger_vat',
                                                        )
                                                    ),
                                                  class: "pl-6 d-flex align-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_icon, null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.isItemExpanded(item0.generalLedgerText)
                                                                ? "$fa-chevron-up"
                                                                : "$fa-chevron-down"), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createElementVNode("h3", _hoisted_96, _toDisplayString(item0.generalLedgerText), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]),
                                                (_ctx.isItemExpanded(item0.generalLedgerText))
                                                  ? (_openBlock(), _createBlock(_component_v_card_text, {
                                                      key: 0,
                                                      transition: "expand",
                                                      class: "px-0 pt-0 pb-2"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_card, { style: {"background-color":"white","border-radius":"25px"} }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_col, { cols: "12" }, {
                                                                  default: _withCtx(() => [
                                                                    (
                                                                        item0.generalLedgerText ===
                                                                            'N - Grand livre - c/445' &&
                                                                        _ctx.isItemExpanded(
                                                                            item0.generalLedgerText,
                                                                        )
                                                                    )
                                                                      ? (_openBlock(), _createElementBlock("div", { key: _ctx.refreshGeneralLedger_vat }, [
                                                                          _createVNode(_component_GeneralLedger, {
                                                                            companyId: _ctx.companyId,
                                                                            accountingPeriodId: 
                                                                            _ctx.accountingPeriodId
                                                                        ,
                                                                            accountableAccountFilter: 
                                                                            item0.accountableAccounts
                                                                        ,
                                                                            inNm1: false,
                                                                            hideOptions: true,
                                                                            withoutLetteringIfHidedOptions: 
                                                                            true
                                                                        ,
                                                                            refreshCount: 
                                                                            _ctx.refreshGeneralLedger_vat
                                                                        
                                                                          }, null, 8, ["companyId", "accountingPeriodId", "accountableAccountFilter", "refreshCount"])
                                                                        ]))
                                                                      : _createCommentVNode("", true)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_card_title, { style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"} }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_v_spacer)
                                                                      ]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["headers", "items", "loading"]),
                          (_ctx.additionalVatAssessmentToDo)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                (!_ctx.disabledOD)
                                  ? (_openBlock(), _createBlock(_component_v_row, {
                                      key: 0,
                                      "no-gutters": "",
                                      class: "py-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "auto" }, {
                                          default: _withCtx(() => _cache[79] || (_cache[79] = [
                                            _createElementVNode("h2", { class: "d-flex align-center pr-4 yellow_custom--text" }, " OD de régularisation des écarts < 5€ ", -1)
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "1" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_tooltip, {
                                              class: "d-flex align-center",
                                              location: "bottom"
                                            }, {
                                              activator: _withCtx(({ props }) => [
                                                _createVNode(_component_v_icon, _mergeProps({
                                                  color: "secondary",
                                                  icon: "$oss-help"
                                                }, props), null, 16)
                                              ]),
                                              default: _withCtx(() => [
                                                _cache[80] || (_cache[80] = _createElementVNode("h3", { class: "mb-0 mt-2" }, "Procédure à suivre :", -1)),
                                                _cache[81] || (_cache[81] = _createElementVNode("br", null, null, -1)),
                                                _cache[82] || (_cache[82] = _createElementVNode("p", { class: "mb-0" }, " - Il est préférable de corriger les écritures, en passant par les grands livres contenus dans chaque section ", -1))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_col, {
                                          cols: "auto",
                                          class: "d-flex text-right align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                              dense: "",
                                              rounded: "",
                                              elevation: "0",
                                              class: "d-inline px-2",
                                              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.createRows())),
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[83] || (_cache[83] = [
                                                _createTextVNode(" OD ")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  class: "py-1 d-flex align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "auto" }, {
                                      default: _withCtx(() => _cache[84] || (_cache[84] = [
                                        _createElementVNode("h2", {
                                          class: "pr-4",
                                          color: "primary"
                                        }, " Déclaration rectificative à effectuer sur la dernière période de l'exercice ", -1)
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "1",
                                      class: "d-flex align-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                          activator: _withCtx(({ props }) => [
                                            _createVNode(_component_v_icon, _mergeProps({
                                              color: "secondary",
                                              icon: "$oss-help"
                                            }, props), null, 16)
                                          ]),
                                          default: _withCtx(() => [
                                            _cache[85] || (_cache[85] = _createElementVNode("h3", { class: "mb-0 mt-2" }, "Procédure à suivre :", -1)),
                                            _cache[86] || (_cache[86] = _createElementVNode("br", null, null, -1)),
                                            _cache[87] || (_cache[87] = _createElementVNode("p", { class: "mb-0" }, " - Remplissez les commentaires (la régularisation va rendre nuls les écarts). ", -1)),
                                            _cache[88] || (_cache[88] = _createElementVNode("p", { class: "mb-0 pl-2" }, [
                                              _createElementVNode("b", null, [
                                                _createElementVNode("i", null, "Exemple : ")
                                              ])
                                            ], -1)),
                                            _cache[89] || (_cache[89] = _createElementVNode("p", { class: "mb-0 pl-2" }, [
                                              _createElementVNode("i", null, "Déclaration rectificative effectuée en 12/2022")
                                            ], -1)),
                                            _cache[90] || (_cache[90] = _createElementVNode("p", { class: "mb-0 pl-2" }, [
                                              _createElementVNode("i", null, "20% HT 650 TVA 130")
                                            ], -1)),
                                            _cache[91] || (_cache[91] = _createElementVNode("br", null, null, -1)),
                                            _cache[92] || (_cache[92] = _createElementVNode("p", { class: "mb-0" }, " - Générez une déclaration rectificative sur la dernière période déclarative (mois ou trimestre) de l'exercice comptable. ", -1)),
                                            _cache[93] || (_cache[93] = _createElementVNode("br", null, null, -1)),
                                            _cache[94] || (_cache[94] = _createElementVNode("p", { class: "mb-2" }, " - Révenez sur le contrôle : ceci déclenchera la mise à jour du tableau ainsi que la validation du contrôle. ", -1))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    (!_ctx.loading && !_ctx.dataLoading)
                      ? (_openBlock(), _createBlock(_component_AuditConnectedAcrDocuments, {
                          key: 8,
                          connectedDocuments: _ctx.connectedDocuments,
                          companyId: _ctx.companyId,
                          acKey: _ctx.key,
                          auditCheckResult: _ctx.auditCheckResult || {},
                          accountingPeriodId: _ctx.accountingPeriodId || undefined,
                          onUnlinkedDocument: _cache[18] || (_cache[18] = ($event: any) => (_ctx.unlinkDocument($event))),
                          onShowLinkedDocument: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showLinkedDocument($event)))
                        }, null, 8, ["connectedDocuments", "companyId", "acKey", "auditCheckResult", "accountingPeriodId"]))
                      : _createCommentVNode("", true),
                    (!_ctx.loading && !_ctx.dataLoading)
                      ? (_openBlock(), _createBlock(_component_AuditConnectedAcrResults, {
                          key: 9,
                          results: _ctx.results,
                          companyId: _ctx.companyId
                        }, null, 8, ["results", "companyId"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_card, {
                      elevation: "0",
                      style: {"background-color":"white","border-radius":"25px"},
                      class: "pa-6 mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "11",
                              class: "ma-auto"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                  default: _withCtx(() => _cache[95] || (_cache[95] = [
                                    _createElementVNode("h5", { class: "pl-4" }, "Commentaires détaillés", -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex align-center px-0 justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "6" }),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center pa-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: 
                                                _ctx.showLongComment ? '$fa-chevron-up' : '$fa-chevron-down'
                                            ,
                                          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showLongComment = !_ctx.showLongComment)),
                                          style: {"width":"40px"},
                                          class: "d-inline px-2"
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.showLongComment)
                          ? (_openBlock(), _createBlock(_component_v_card_text, {
                              key: 0,
                              "no-gutters": ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { class: "pt-6" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { style: {"padding-top":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_textarea, {
                                          modelValue: _ctx.longComment,
                                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.longComment) = $event)),
                                          "auto-grow": "",
                                          class: "pt-1",
                                          style: {"border":"1px #ededed solid"}
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_v_row, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_spacer),
                                            _createVNode(_component_v_col, {
                                              cols: "auto",
                                              class: "pt-6"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, { class: "text-right" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "auto",
                                                      class: "text-right"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (
                                                            !_ctx.accountingPeriod ||
                                                            (_ctx.accountingPeriod &&
                                                                _ctx.accountingPeriod.closed)
                                                        )
                                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                                              key: 0,
                                                              rounded: "",
                                                              disabled: "",
                                                              size: "small"
                                                            }, {
                                                              default: _withCtx(() => _cache[96] || (_cache[96] = [
                                                                _createTextVNode(" Enregistrer ")
                                                              ])),
                                                              _: 1
                                                            }))
                                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                                              key: 1,
                                                              rounded: "",
                                                              elevation: "0",
                                                              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.validateAuditCheckResult())),
                                                              size: "small"
                                                            }, {
                                                              default: _withCtx(() => _cache[97] || (_cache[97] = [
                                                                _createTextVNode(" Enregistrer ")
                                                              ])),
                                                              _: 1
                                                            }))
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card, {
                      elevation: "0",
                      style: {"background-color":"white","border-radius":"25px"},
                      class: "pa-6 mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "11",
                              class: "ma-auto"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                  default: _withCtx(() => _cache[98] || (_cache[98] = [
                                    _createElementVNode("h5", { class: "pl-4" }, "Commentaires synthétiques", -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex align-center px-0 justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "6" }),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center pa-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: 
                                                _ctx.showShortComment ? '$fa-chevron-up' : '$fa-chevron-down'
                                            ,
                                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.showShortComment = !_ctx.showShortComment)),
                                          style: {"width":"40px"},
                                          class: "d-inline px-2"
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.showShortComment)
                          ? (_openBlock(), _createBlock(_component_v_card_text, {
                              key: 0,
                              "no-gutters": ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { class: "pt-6" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { style: {"padding-top":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_textarea, {
                                          modelValue: _ctx.shortComment,
                                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.shortComment) = $event)),
                                          "auto-grow": "",
                                          style: {"border":"1px #ededed solid"},
                                          outlined: ""
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_v_row, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_spacer),
                                            _createVNode(_component_v_col, {
                                              cols: "auto",
                                              class: "pt-6"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, { class: "text-right" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "auto",
                                                      class: "text-right"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (
                                                            !_ctx.accountingPeriod ||
                                                            (_ctx.accountingPeriod &&
                                                                _ctx.accountingPeriod.closed)
                                                        )
                                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                                              key: 0,
                                                              rounded: "",
                                                              disabled: "",
                                                              size: "small"
                                                            }, {
                                                              default: _withCtx(() => _cache[99] || (_cache[99] = [
                                                                _createTextVNode(" Enregistrer ")
                                                              ])),
                                                              _: 1
                                                            }))
                                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                                              key: 1,
                                                              rounded: "",
                                                              elevation: "0",
                                                              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.validateAuditCheckResult())),
                                                              size: "small"
                                                            }, {
                                                              default: _withCtx(() => _cache[100] || (_cache[100] = [
                                                                _createTextVNode(" Enregistrer ")
                                                              ])),
                                                              _: 1
                                                            }))
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ], 64)),
              _createVNode(_component_oss_dialog, {
                modelValue: _ctx.miscellaneousOperationDialog,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.miscellaneousOperationDialog) = $event)),
                actions: _ctx.actionsMiscellaneousOperation,
                "min-width": "90vw"
              }, {
                default: _withCtx(() => [
                  (_ctx.miscellaneousOperationDialog)
                    ? (_openBlock(), _createBlock(_component_AccountingItemEdition2, {
                        key: 0,
                        companyId: _ctx.companyId,
                        prefilledRows: _ctx.miscellanousOperationData,
                        acKey: _ctx.key,
                        auditCheckResult: _ctx.auditCheckResult,
                        accountingPeriodId: _ctx.accountingPeriodId,
                        onUpsert: _cache[26] || (_cache[26] = ($event: any) => (_ctx.refresh())),
                        accountingItemType: 'MISCELLANEOUS_OPERATION',
                        actions: _ctx.actionsMiscellaneousOperation
                      }, null, 8, ["companyId", "prefilledRows", "acKey", "auditCheckResult", "accountingPeriodId", "actions"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue", "actions"]),
              (_ctx.displayActivityDialog)
                ? (_openBlock(), _createBlock(_component_oss_dialog, {
                    key: 2,
                    modelValue: _ctx.displayActivityDialog,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.displayActivityDialog) = $event)),
                    title: "Activité",
                    "valid-title": "Fermer",
                    onValid: _cache[29] || (_cache[29] = ($event: any) => (_ctx.displayActivityDialog = false)),
                    onClose: _cache[30] || (_cache[30] = ($event: any) => (_ctx.displayActivityDialog = false)),
                    "min-width": "60vw"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UsersActivitiesHistory, {
                        auditCheckKey: _ctx.acKey,
                        accountingPeriodId: _ctx.accountingPeriodId
                      }, null, 8, ["auditCheckKey", "accountingPeriodId"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              (_ctx.openChat)
                ? (_openBlock(), _createBlock(_component_Chat, {
                    key: 3,
                    auditCheckAccountingPeriodKey: _ctx.chatId,
                    chatTitle: 'Chat'
                  }, null, 8, ["auditCheckAccountingPeriodKey"]))
                : _createCommentVNode("", true),
              (_ctx.dialogAuditCheckDocumentsManager)
                ? (_openBlock(), _createBlock(_component_AuditCheckDocumentsManager, {
                    key: 4,
                    modelValue: _ctx.dialogAuditCheckDocumentsManager,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.dialogAuditCheckDocumentsManager) = $event)),
                    companyId: _ctx.companyId,
                    documentToDisplay: _ctx.documentToDisplay,
                    connectedDocuments: _ctx.connectedDocuments || [],
                    acKey: _ctx.key,
                    auditCheckResult: _ctx.auditCheckResult || {},
                    accountingPeriodId: _ctx.accountingPeriodId || undefined,
                    alreadyLinkedDoc: _ctx.alreadyLinkedDoc,
                    onUpsertedAuditCheckResult: _ctx.upsertedACR,
                    onResetDialogData: _cache[32] || (_cache[32] = ($event: any) => {
                        _ctx.alreadyLinkedDoc = false;
                        _ctx.documentToDisplay = {};
                    })
                  }, null, 8, ["modelValue", "companyId", "documentToDisplay", "connectedDocuments", "acKey", "auditCheckResult", "accountingPeriodId", "alreadyLinkedDoc", "onUpsertedAuditCheckResult"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      (_ctx.globalStep === 1)
                        ? (_openBlock(), _createBlock(_component_DeclarationForm, {
                            key: 0,
                            closureVatMode: true,
                            closureVatItems: _ctx.gapsResumeTable[2],
                            cerfaNumber: '3310CA3',
                            propsStartDate: _ctx.declarationStartDate,
                            propsEndDate: _ctx.declarationEndDate,
                            closureLastDeclarationData: 
                                _ctx.gapsResumeTable[1].table[_ctx.gapsResumeTable[1].table.length - 1]
                            ,
                            onDeclarationSent: _ctx.refresh,
                            onBack: _cache[33] || (_cache[33] = ($event: any) => (_ctx.globalStep--))
                          }, null, 8, ["closureVatItems", "propsStartDate", "propsEndDate", "closureLastDeclarationData", "onDeclarationSent"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}